import { render, staticRenderFns } from "./debugging-support.page.vue?vue&type=template&id=523c7e9e&scoped=true&"
import script from "./debugging-support.page.vue?vue&type=script&lang=js&"
export * from "./debugging-support.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c7e9e",
  null
  
)

export default component.exports